<style lang="scss" scoped>
section {
    margin-top: 150px;
    padding-top: 30px;
    .preview {
        max-width: 600px;
    }
}
</style>

<template>
    <section class="container grid grid-cols-12">
        <div class="col-span-12 lg:col-span-5 flex flex-col justify-end pb-60 md:pb-120 lg:pb-200">
            <div class="text-yellow mb-24 text-24 font-light">{{ data.subtitle }}</div>
            <h1 class="text-34 lg:text-64 font-medium mb-24" v-html="nl2br(data.title)"></h1>
            <div class="text-16 lg:text-24 text-white font-light">{{ data.description }}</div>
            <hero-video v-if="data.video_check"
                :cta="data.video_cta"
                :title="data.video_title"
                :video-id="data.vimeo_id"
                :thumbnail="data.video_thumbnail[0]['thumbnail_large']"></hero-video>
            <div v-if="data.link" class="link-list flex flex-wrap mt-40">
                <a :href="data.link.url" :target="data.link.target" class="text-button rounded-button border border-yellow bg-yellow font-bold px-40 py-24 transition-colors hover:bg-transparent hover:text-yellow">{{ data.link.title }}</a>
            </div>
        </div>
        <div class="col-span-12 lg:col-span-7">
            <img v-if="data && data.image" :data-src="data.image.url" :alt="data.image.alt" class="lazyload preview ml-auto mr-40 w-100" />
        </div>
        <div class="col-span-12 p-30 lg:p-80 bg-dark-blue rounded-34">
            <h2 class="text-24 lg:text-48 mb-24 font-regular" v-html="data.second_title"></h2>
            <div class="text-16 lg:text-24 text-white font-light">
                {{ data.second_description }}
            </div>
        </div>
    </section>
</template>

<script>
export default {
    props: {
        data: {
            required: true,
            default: () => ({
                id: "",
                title: "",
                content: ""
            })
        }
    },
    methods: {
        nl2br(content) {
            if (!content) {
                return "";
            }
            return content.replace(/\n/g, "<br />");
        }
    }
};
</script>
